<template>
  <ConditionInsights
    :azureId="azureId"
    :authToken="authToken"
    :orgId="orgId"
  />
</template>

<script>
import auth from "@/authConfig"
import ConditionInsights from "@/components/Insights/ConditionInsights.vue"

export default {
  name: "Insights",
  components: {
    ConditionInsights
  },
  data() {
    return {
      token: null,
      authToken: "",
      azureId: "",
      orgId: null
    }
  },
  methods: {
    async initAuth() {
      this.token = await auth.acquireTokenResponse()
      this.authToken = this.token?.accessToken || this.token?.idToken || ""
      this.azureId = localStorage.getItem("azure_id") || ""
    }
  },
  async mounted() {
    await this.initAuth()
  }
}
</script>

<style scoped>
.page-shell {
  width: 100%;
  min-height: 100%;
  padding: 12px;
}

.page-title {
  font-weight: 900;
  font-size: 16px;
}
</style>
